var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"extraKeyboardKey",attrs:{"id":_vm.id,"disabled":_vm.disabled},domProps:{"innerHTML":_vm._s(_vm.keyLabel)},on:{"click":function($event){return _vm.$emit('extraKeyClick', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }